import React from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Phone, WhatsApp } from "@mui/icons-material";
import { useLocation, matchPath } from "react-router-dom";
import {
  PRIMARY_PHONE,
  toTelHref,
  toWhatsAppHref,
} from "../../constants/contactPhones";

const NAVY = "#1a1a2e";

const actionButtonSx = {
  width: { xs: 40, sm: 44 },
  height: { xs: 40, sm: 44 },
  bgcolor: NAVY,
  color: "#fff",
  "&:hover": {
    bgcolor: "#252542",
  },
};

const FloatingContactBar = () => {
  const location = useLocation();
  const phone = PRIMARY_PHONE;

  const isAuthPage =
    [
      "/ForgetPassword",
      "/VerifyOTP",
      "/reset-password",
      "/forget-password",
      "/verify-otp",
    ].includes(location.pathname) ||
    Boolean(matchPath("/verification/:token/:user", location.pathname));

  if (isAuthPage) {
    return null;
  }

  const telHref = toTelHref(phone);
  const whatsAppHref = toWhatsAppHref(phone);

  return (
    <Box
      component="nav"
      aria-label="Quick contact"
      sx={{
        position: "fixed",
        right: 0,
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 1100,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 0.75, sm: 1 },
        py: { xs: 1.25, sm: 1.5 },
        px: { xs: 0.5, sm: 0.75 },
        background:
          "linear-gradient(180deg, rgba(255, 232, 212, 0.98) 0%, rgba(245, 212, 168, 0.98) 100%)",
        borderTopLeftRadius: { xs: 20, sm: 24 },
        borderBottomLeftRadius: { xs: 20, sm: 24 },
        boxShadow: "-3px 0 14px rgba(26, 26, 46, 0.12)",
        border: "1px solid rgba(232, 180, 120, 0.55)",
        borderRight: "none",
        pointerEvents: "auto",
      }}
    >
      <Tooltip title="Call us" placement="left">
        <IconButton
          component="a"
          href={telHref}
          aria-label={`Call ${phone}`}
          sx={actionButtonSx}
        >
          <Phone sx={{ fontSize: { xs: 20, sm: 22 } }} />
        </IconButton>
      </Tooltip>
      <Tooltip title="WhatsApp" placement="left">
        <IconButton
          component="a"
          href={whatsAppHref}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`WhatsApp ${phone}`}
          sx={actionButtonSx}
        >
          <WhatsApp sx={{ fontSize: { xs: 20, sm: 22 } }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default FloatingContactBar;
